import DeleteModal from "components/Common/DeleteModal"
import Filters from "components/Common/Filters"
import Paginations from "components/Common/Paginations"

import TableShimmer from "components/Shared/TableShimmer"
import formatDateTime from "components/Shared/formatDateTime"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { Badge, CardText, CardTitle, Col, Row, Table } from "reactstrap"
import {
  deleteScheduleNotification,
  getNotificationHistory,
} from "store/actions/pushNotificationAction"

const ScheduleNotification = ({ activeTab, t, language }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const pageNumber = parseInt(searchParams.get("page")) || 1
  const dispatch = useDispatch()

  const {
    loading,
    isLoading,
    itemsPerPage,
    totalCount,
    totalPages,
    currentPage,
    notificationHistory,
  } = useSelector(state => state.PushNotifications)

  const [searchTerm, setSearchTerm] = useState("")
  const [isApiCalled, setIsApiCalled] = useState(false)
  const [itemIdToDelete, setItemIdToDelete] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const [selectedFilters, setSelectedFilters] = useState({
    status: 0,
    sortOrder: 1,
  })

  useEffect(() => {
    activeTab === "2" && fetchNotificationHistory()
  }, [activeTab])

  const fetchNotificationHistory = () => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: pageNumber,
      status: 1, //0:all,1:"scheduled" or 2:"sent"
      orderBy: 1,
      keyword: "",
    }
    // console.log(payload)
    dispatch(getNotificationHistory(payload))
    setIsApiCalled(true)
  }
  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }

  const filters = [
    // {
    //   name: "status",
    //   type: "select",
    //   options: [
    //     { label: "All", value: 0 },
    //     { label: "Schedule", value: 1 },
    //     { label: "Sent", value: 2 },
    //   ],
    //   placeholder: "All",
    // },
    {
      name: "sortOrder",
      type: "select",
      options: [
        { label: t("Ascending"), value: 1 },
        { label: t("Descending"), value: 2 },
      ],
      placeholder: t("Ascending"),
    },
  ]

  const handleFilterChange = (selectedValue, filterName) => {
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: selectedValue,
    }))
  }

  const getApiCall = (page = 1) => {
    const { status, sortOrder } = selectedFilters
  
    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      status: Number(status), // Assuming `status` should be dynamic
      orderBy: Number(sortOrder),
      keyword: searchTerm || "",
    }
  
    return dispatch(getNotificationHistory(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/push-notifications?page=${page}`)
        }
      })
      .catch(error => {
        console.error(error)
      })
  }
  
  const handleSearch = () => {
    getApiCall() // Calls with default page = 1
  }
  
  const onPageChange = page => {
    getApiCall(page)
  }

  // useEffect(() => {
  //   if (isApiCalled) {
  //     const delayDebounceFn = setTimeout(() => {
  //       handleSearch()
  //     }, 500)

  //     return () => clearTimeout(delayDebounceFn)
  //   }
  // }, [searchTerm])

  // useEffect(() => {
  //   if (isApiCalled) {
  //     handleSearch()
  //   }
  // }, [selectedFilters])

 

  const handleDelete = () => {
    const payload = {
      id: itemIdToDelete,
      status: "2", // 2 FOR DELETE
    }
    dispatch(deleteScheduleNotification(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          setShowDeleteModal(false)
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <Row>
      <Col sm="12">
        <Filters
          filters={filters}
          searchTerm={searchTerm}
          handleSearchChange={handleSearchChange}
          handleFilterChange={handleFilterChange}
          handleSearch={handleSearch}
          selectedFilters={selectedFilters}
          searchBy={t("Name")}
        />
        <div className="table-responsive">
          {loading ? (
            <TableShimmer row={7} col={7} />
          ) : notificationHistory.length === 0 ? (
            <p className="text-center my-2">
              {t("No scheduled notifications found")}
            </p>
          ) : (
            <Table className="table mb-0 capitalize_td">
              <thead className="table-light full_th">
                <tr>
                  <th>{t("S. No.")}</th>
                  <th>{t("Title")}</th>
                  <th>{t("Message")}</th>
                  <th>{t("Type")}</th>
                  <th>{t("Status")}</th>
                  <th>{t("Scheduled Time")}</th>
                  <th>{t("Action")}</th>
                </tr>
              </thead>
              <tbody>
                {notificationHistory.map(
                  (
                    {
                      _id,
                      title,
                      body,
                      type,
                      actionType,
                      status,
                      hidden,
                      remark,
                      scheduledTime,
                      isScheduled,
                    },
                    index
                  ) => (
                    <React.Fragment key={_id}>
                      <tr
                      // onClick={() =>
                      //   navigate(
                      //     `/app-notifications/app-notification-details?id=${_id}`
                      //   )
                      // }
                      // className="cursor-pointer"
                      >
                        <td>{(currentPage - 1) * 10 + index + 1}</td>

                        <td>
                          {" "}
                          {language === "sa"
                            ? title?.ar
                            : title?.en || "-"}{" "}
                        </td>
                        <td>
                          {language === "sa" ? body?.ar : body?.en || "-"}
                        </td>
                        <td>
                          {type === "all" && t("All")}
                          {type === "specific-customers" &&
                            t("Specific Customers")}
                        </td>
                        <td>{t(status)}</td>
                        <td>{formatDateTime(scheduledTime)}</td>
                        <td>
                          {isScheduled ? (
                            <i
                              onClick={e => {
                                e.stopPropagation()
                                setItemIdToDelete(_id)
                                setShowDeleteModal(true)
                              }}
                              className="mdi mdi-trash-can font-size-16 text-danger me-1 cursor-pointer"
                            ></i>
                          ) : (
                            "-"
                          )}
                        </td>
                      </tr>
                    </React.Fragment>
                  )
                )}
              </tbody>
            </Table>
          )}
        </div>
        {!loading && (
          <div className="mt-4">
            <Paginations
              data={notificationHistory}
              itemsPerPage={itemsPerPage}
              onPageChange={onPageChange}
              currentPage={currentPage}
              totalPages={totalPages}
              totalCount={totalCount}
            />
          </div>
        )}
      </Col>
      <DeleteModal
        show={showDeleteModal}
        isLoading={isLoading}
        onDeleteClick={handleDelete}
        onCloseClick={() => setShowDeleteModal(false)}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to remove this Notification?")}
      />
    </Row>
  )
}

export default ScheduleNotification
